import { createSlice } from '@reduxjs/toolkit';

export interface BlockSliceState {
  isBlocked: boolean;
}

const initialState: BlockSliceState = {
  isBlocked: false,
};

const blockSlice = createSlice({
  name: 'block',
  initialState,
  reducers: {
    block: (state) => {
      state.isBlocked = true;
    },
    unblock: (state) => {
      state.isBlocked = false;
    },
  },
});

export { blockSlice };
